import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import Layout from "./Layout";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const { isDark } = useTheme();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      {({ toggleMobileMenu }) => (
        <div className="flex flex-col items-center justify-center px-4 py-12 min-h-screen">
          <div className="w-full max-w-md text-center">
            {/* 404 Icon */}
            <div className="mb-8">
              <h1
                className={`text-9xl font-display font-bold ${
                  isDark ? "text-gray-800" : "text-gray-200"
                }`}
              >
                404
              </h1>
            </div>

            {/* Message */}
            <h2
              className={`text-3xl font-display font-semibold mb-4 ${
                isDark ? "text-white" : "text-text"
              }`}
            >
              Page Not Found
            </h2>

            <p
              className={`text-base mb-8 ${
                isDark ? "text-gray-400" : "text-text-muted"
              }`}
            >
              The page you're looking for doesn't exist or has been moved.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border transition-all duration-base ${
                  isDark
                    ? "bg-primary-dark text-background-dark border-primary-dark hover:bg-opacity-90"
                    : "bg-primary text-white border-primary hover:bg-primary-hover"
                }`}
              >
                <Home size={20} />
                Go to Home
              </Link>

              <button
                onClick={() => window.history.back()}
                className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border transition-all duration-base ${
                  isDark
                    ? "text-gray-400 border-border-dark hover:text-white hover:border-primary-dark/50 hover:bg-border-dark"
                    : "text-text-muted border-border/50 hover:text-text hover:border-primary/50 hover:bg-secondary/20"
                }`}
              >
                <ArrowLeft size={20} />
                Go Back
              </button>
            </div>

            {/* Helpful Links */}
            <div className="mt-12">
              <p
                className={`text-sm mb-4 ${
                  isDark ? "text-gray-500" : "text-text-light"
                }`}
              >
                Or try one of these:
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link
                  to="/portfolio"
                  className={`text-sm transition-colors duration-base ${
                    isDark
                      ? "text-gray-400 hover:text-primary-dark"
                      : "text-text-muted hover:text-primary"
                  }`}
                >
                  Portfolio
                </Link>
                <span className={isDark ? "text-gray-600" : "text-text-light"}>
                  •
                </span>
                <Link
                  to="/about"
                  className={`text-sm transition-colors duration-base ${
                    isDark
                      ? "text-gray-400 hover:text-primary-dark"
                      : "text-text-muted hover:text-primary"
                  }`}
                >
                  About
                </Link>
                <span className={isDark ? "text-gray-600" : "text-text-light"}>
                  •
                </span>
                <Link
                  to="/tags/backend"
                  className={`text-sm transition-colors duration-base ${
                    isDark
                      ? "text-gray-400 hover:text-primary-dark"
                      : "text-text-muted hover:text-primary"
                  }`}
                >
                  Blog Topics
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
